import { api } from 'services';
import {
  ScheduledReportType,
  ScheduledReportFilterParams,
} from 'contracts/scheduledRepports';

export type ScheduleReportPayload = {
  type: ScheduledReportType;
  params: ScheduledReportFilterParams & {
    [key: string]: unknown;
  };
};

export function useScheduleReport() {
  const scheduleReport = async (payload: ScheduleReportPayload) => {
    await api.post('/scheduled-reports', payload);
  };

  return {
    scheduleReport,
  };
}
